import { createStore } from "vuex";
import persistedStateVuex from "persisted-state-vuex";

export default createStore({
  state: {
    userLogged: null,
    publicId: null,
    selectedPaymentOption: null,
    selectedInstallment: null,
    planDetails: {
      xendit_id: null,
      referenceNumber: null,
      planName: null,
      planholderid: null,
      plantypeid: null,
      premium: null,
      amountPay: null,
    },
  },
  getters: {},
  mutations: {
    getUserLogged(state, value) {
      console.log(value);
      state.userLogged = value.name;
      state.publicId = value.publicId;
      state.schema = value.schema;
    },
    SET_PLAN_DETAILS(state, plan) {
      state.planDetails = {
        ...state.planDetails,
        ...plan,
      };
    },
    SET_SELECTED_INSTALLMENT(state, payload) {
      state.selectedInstallment = payload;
    },
    SET_PAYMENT_OPTION(state, payload) {
      state.selectedPaymentOption = payload;
    },
  },
  actions: {},
  modules: {},
  plugins: [persistedStateVuex.init],
});
